"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _Caption = _interopRequireDefault(require("../components/Caption"));

var _store = require("../store"); // import app components


var Home = function Home() {
  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 1),
      authUser = _ref2[0].authState.authUser;

  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    pageTitle: "Profile"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 40
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Personal Information"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 2
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Email"
  }), /*#__PURE__*/_react.default.createElement(_antd.Typography, null, authUser === null || authUser === void 0 ? void 0 : authUser.email)), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 2
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Role"
  }), /*#__PURE__*/_react.default.createElement(_antd.Typography, null, authUser === null || authUser === void 0 ? void 0 : authUser.role))))));
};

var _default = Home;
exports.default = _default;